// loader.js
class Loader {
  static #instance = null;
  static #styleId = "loader-styles";
  #overlayElements = new Map();

  constructor() {
    if (Loader.#instance) {
      return Loader.#instance;
    }
    Loader.#instance = this;
    this.#addStyles();
  }

  #addStyles() {
    if (document.getElementById(Loader.#styleId)) return;

    const style = document.createElement("style");
    style.id = Loader.#styleId;
    style.textContent = `
      .loader__overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.8);
        z-index: 100;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .loader__overlay .ellipsis {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
      }
      .loader__overlay .ellipsis div {
        position: absolute;
        top: 33px;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        background: #40608e;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
      }
      .loader__overlay .ellipsis div:nth-child(1) {
        left: 8px;
        animation: lds-ellipsis1 0.6s infinite;
      }
      .loader__overlay .ellipsis div:nth-child(2) {
        left: 8px;
        animation: lds-ellipsis2 0.6s infinite;
      }
      .loader__overlay .ellipsis div:nth-child(3) {
        left: 32px;
        animation: lds-ellipsis2 0.6s infinite;
      }
      .loader__overlay .ellipsis div:nth-child(4) {
        left: 56px;
        animation: lds-ellipsis3 0.6s infinite;
      }
      @keyframes lds-ellipsis1 {
        0% { transform: scale(0); }
        100% { transform: scale(1); }
      }
      @keyframes lds-ellipsis3 {
        0% { transform: scale(1); }
        100% { transform: scale(0); }
      }
      @keyframes lds-ellipsis2 {
        0% { transform: translate(0, 0); }
        100% { transform: translate(24px, 0); }
      }
    `;
    document.head.appendChild(style);
  }

  #createOverlay() {
    const overlay = document.createElement("div");
    overlay.className = "loader__overlay";
    overlay.innerHTML = `
      <div class="ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    `;
    return overlay;
  }

  #getElement(element) {
    if (element instanceof jQuery) {
      return element[0];
    }
    return element;
  }

  show(element) {
    const domElement = this.#getElement(element);

    if (!(domElement instanceof Element) && domElement !== document.body) {
      throw new Error("Invalid element provided");
    }

    if (!this.#overlayElements.has(domElement)) {
      const overlay = this.#createOverlay();
      this.#overlayElements.set(domElement, overlay);
    }

    const overlay = this.#overlayElements.get(domElement);
    domElement.appendChild(overlay);

    if (domElement !== document.body) {
      domElement.style.position = "relative";
    }
  }

  hide(element) {
    const domElement = this.#getElement(element);

    if (!this.#overlayElements.has(domElement)) return;

    const overlay = this.#overlayElements.get(domElement);
    if (overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }

    if (domElement !== document.body) {
      domElement.style.position = "";
    }
  }

  static getInstance() {
    if (!this.#instance) {
      this.#instance = new Loader();
    }
    return this.#instance;
  }
}

export const loader = Loader.getInstance();

export function showLoader(element) {
  loader.show(element);
}

export function hideLoader(element) {
  loader.hide(element);
}

// jQuery plugin
if (typeof jQuery !== "undefined") {
  jQuery.fn.loader = function (action) {
    return this.each(function () {
      if (action === "show") {
        showLoader(this);
      } else if (action === "hide") {
        hideLoader(this);
      }
    });
  };
}
